document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.share-button').forEach(shareButton => {
        const copyButton = shareButton.querySelector('.share-button__copy');
        const inputField = shareButton.querySelector('.field__input');
        const message = shareButton.querySelector('.share-button__message');
        const closeButton = shareButton.querySelector('.share-button__close');
        const detailsElement = shareButton.querySelector('details');

        // Ensure input field exists and has a valid value
        if (!inputField || !inputField.value.trim()) {
            console.error("Share button: Input field is missing or empty.");
            return;
        }

        // Copy link functionality
        if (copyButton) {
            copyButton.addEventListener('click', function () {
                if (navigator.clipboard && window.isSecureContext) {
                    // Use Clipboard API for modern browsers
                    navigator.clipboard.writeText(inputField.value)
                        .then(() => showCopySuccessMessage())
                        .catch(err => {
                            console.error('Clipboard API failed, using fallback', err);
                            fallbackCopy(inputField);
                        });
                } else {
                    // Fallback for older browsers
                    fallbackCopy(inputField);
                }
            });
        }

        function fallbackCopy(input) {
            try {
                input.select();
                input.setSelectionRange(0, 99999); // For mobile devices
                document.execCommand('copy'); // Execute the copy command
                showCopySuccessMessage();
            } catch (err) {
                console.error('Fallback copy method failed', err);
            }
        }

        function showCopySuccessMessage() {
            if (message) {
                message.textContent = "Copied!";
                message.classList.remove('hidden');

                setTimeout(() => {
                    message.classList.add('hidden');
                }, 2000);
            }
        }

        // Close button functionality
        if (closeButton && detailsElement) {
            closeButton.addEventListener('click', function () {
                detailsElement.removeAttribute('open');
            });
        }
    });
});
